import 'jquery-validation';

$(function () {
	/* ==============================
	   Newsletter Subscription Form Validation + AJAX
	   ============================== */
	if ($('#newsletterForm').length) {
		$('#newsletterForm').validate({
			rules: {
				email: {
					required: true,
					email: true
				},
				newsletter_consent: {
					required: true
				}
			},
			messages: {
				email: {
					required: window.Lang.val_newsletter_email_required,
					email: window.Lang.val_newsletter_email_invalid
				},
				newsletter_consent: {
					required: window.Lang.val_newsletter_consent_required
				}
			},
			errorElement: 'span',
			errorClass: 'footer-newsletter-error',
			errorPlacement: function (error, element) {
				if (element.attr('type') === 'checkbox') {
					error.insertAfter(element.closest('.footer-newsletter-consent'));
				} else {
					error.insertAfter(element.closest('.footer-newsletter'));
				}
			},
			submitHandler: function (form) {
				var $form = $(form);
				var $btn = $form.find('[type="submit"]');
				$btn.prop('disabled', true);

				$.ajax({
					url: $form.attr('action'),
					method: 'POST',
					data: $form.serialize(),
					dataType: 'json',
					success: function (res) {
						GlobalSwal.fire({
							title: window.Lang.success_title,
							text: res.message || window.Lang.newsletter_subscribe_success,
							icon: 'success',
							confirmButtonText: window.Lang.confirm_button
						});
						form.reset();
						$btn.prop('disabled', false);
					},
					error: function (xhr) {
						var errors = xhr.responseJSON && xhr.responseJSON.errors;
						var msg = errors ? Object.values(errors).flat().join('\n') : window.Lang.newsletter_subscribe_error;
						GlobalSwal.fire({
							title: window.Lang.error_title,
							text: msg,
							icon: 'error',
							confirmButtonText: window.Lang.confirm_button
						});
						$btn.prop('disabled', false);
					}
				});
			}
		});
	}
});
